import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  modalWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.xl,

    padding: SPACES.xxl,

    minHeight: 340,
    maxHeight: 'calc(100vh - 80px)',
    maxWidth: 'calc(100vw - 40px)',
  },
  tableHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  title: {
    '&&': {
      textAlign: 'center',
      fontSize: FONTS.SIZES.xl,
      fontWeight: FONTS.WEIGHTS.bold,
      color: theme.palette.custom.darkBlue2,
    },
  },
}))
